module.exports = __webpack_public_path__ + "img/tron-icon.fe7a90ad.png";